module.exports = __webpack_public_path__ + "static/media/work5.027ed833.jpg";